import { parseMoneyInput } from '@/features/shiftCloseouts/utils/moneyInput'
import currencyJs from 'currency.js'

export const isValidCashTransactionAmount = (amountInput: string): boolean => {
    const amount = parseMoneyInput(amountInput)

    return Boolean(amount && currencyJs(amount).value > 0)
}
